import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AuthImage } from "@/components/AuthImage";

export function BottleThumb({ fileId, className = "h-20 w-16", alt = "Pigment bottle", testId }) {
  if (!fileId) {
    return (
      <div className={`${className} flex shrink-0 items-center justify-center rounded-xl border border-dashed border-[#E6DBCF] bg-[#F6F1EA] text-[#C9B8A8]`} data-testid={testId ? `${testId}-empty` : undefined}>
        <Camera size={16} strokeWidth={1.5} />
      </div>
    );
  }
  return <AuthImage id={fileId} alt={alt} className={`${className} shrink-0 rounded-xl object-cover`} testId={testId} />;
}

export function BottlePhotoControl({ fileId, endpoint, onChange, testId, label = "bottle photo", highlight = false }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const run = async (fn, msg) => {
    setBusy(true);
    try {
      await fn();
      toast.success(msg);
      onChange();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      if (input.current) input.current.value = "";
    }
  };
  const upload = (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    run(() => api.post(endpoint, fd), "Bottle photo saved");
  };
  const btn = "inline-flex items-center gap-1 rounded-full border border-[#E6DBCF] px-2.5 py-1 text-[11px] font-medium text-[#6E5549] transition-colors hover:border-[#C5A059] hover:text-[#2C1810] disabled:opacity-50";
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid={`${testId}-input`} />
      <button type="button" className={highlight && !fileId ? `${btn} border-[#D99B90] bg-[#FDF2F0] text-[#2C1810] ig-pulse-soft` : btn} disabled={busy} onClick={() => input.current?.click()} data-testid={`${testId}-upload-btn`}>
        {busy ? <Loader2 size={12} className="animate-spin" /> : <Camera size={12} />} {fileId ? "Replace" : "Add"} {label}
      </button>
      {fileId && (
        <button type="button" className={btn} disabled={busy} onClick={() => run(() => api.delete(endpoint), "Bottle photo removed")} data-testid={`${testId}-remove-btn`} aria-label="Remove photo">
          <X size={12} /> Remove
        </button>
      )}
    </span>
  );
}
